import Vue from "vue";
import vueLoading from "./loading.vue";

export default (function () {
  const loading = new (Vue.extend(vueLoading));
  document.body.appendChild(loading.$mount().$el);
  return {
    show () {
      loading.show();
    },
    hide () {
      loading.hide();
    }
  }
})();